<svg
  class="block"
  [attr.width]="width"
  [attr.height]="height"
  fill="none"
  preserveAspectRatio="none"
  viewBox="0 0 26 21"
>
  <g>
    <path
      clip-rule="evenodd"
      d="M6.04831 10.778C6.41311 10.4259 6.41311 9.84071 6.04831 9.48858L0.273576 3.90638C-0.0823576 3.56184 -0.0924907 2.99438 0.252043 2.63844L2.53838 0.273576C2.88291 -0.0823571 3.45038 -0.0924912 3.80631 0.252042L11.1226 7.32384C12.711 8.86031 12.711 11.4063 11.1226 12.9415L3.80631 20.0133C3.45038 20.3578 2.88291 20.3477 2.53838 19.9918L0.252043 17.6269C-0.0924907 17.271 -0.0823576 16.7022 0.273576 16.359L6.04831 10.7768V10.778Z"
      fill="var(--fill-0, #1A73E8)"
      fill-rule="evenodd"
    ></path>
    <path
      clip-rule="evenodd"
      d="M19.4151 10.778C19.7799 10.4259 19.7799 9.84071 19.4151 9.48858L13.6404 3.90638C13.2844 3.56184 13.2743 2.99438 13.6188 2.63844L15.9052 0.273576C16.2497 -0.0823571 16.8172 -0.0924912 17.1731 0.252042L24.4894 7.32384C26.0778 8.86031 26.0778 11.4063 24.4894 12.9415L17.1731 20.0133C16.8172 20.3578 16.2497 20.3477 15.9052 19.9918L13.6188 17.6269C13.2743 17.271 13.2844 16.7035 13.6404 16.359L19.4151 10.7768V10.778Z"
      fill="var(--fill-0, #1A73E8)"
      fill-rule="evenodd"
    ></path>
  </g>
</svg>
